import { useQuery } from "react-query";
import { EStudentProgressQueryKeys } from "api/endpoints/student-progress";
import { getStudentProgress } from "api/services/student-progress";
import { TStudentProgress } from "types/api/progress";
import { TApiError } from "types/api/error";

type TUseStudentProgressOptions = {
  enabled?: boolean;
};

export const useStudentProgress = (options?: TUseStudentProgressOptions) => {
  return useQuery<TStudentProgress[], TApiError>(
    EStudentProgressQueryKeys.getStudentProgress,
    getStudentProgress,
    {
      retry: false,
      staleTime: 5 * 60 * 1000, // 5 minutes
      cacheTime: 10 * 60 * 1000, // 10 minutes
      enabled: options?.enabled ?? true,
    }
  );
};
